import { render, staticRenderFns } from "./CellValue.vue?vue&type=template&id=2ae98b0b&scoped=true"
import script from "./CellValue.vue?vue&type=script&lang=js"
export * from "./CellValue.vue?vue&type=script&lang=js"
import style0 from "./CellValue.vue?vue&type=style&index=0&id=2ae98b0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae98b0b",
  null
  
)

export default component.exports